export default "__VITE_ASSET__CZVhNES4__"